import React, { useEffect, useRef, useState } from 'react'
import { FaArrowLeft } from 'react-icons/fa6'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Header from './partial/Header'
import Sidebar from './partial/Sidebar'
import JoditEditor from 'jodit-react';
import { useGetBlogDetailsQuery, useUpdateBlogMutation } from '../../redux/API/BlogApi'
import toast, { Toaster } from 'react-hot-toast'
import ChangePassword from './partial/ChangePassword'
import { blogImgUrl, ImgUrl } from '../Constant'


const UpdateBlog = () => {
const [newClass, setNewClass] = useState("")
const [newSidebarClass, setNewSidebarClass] = useState("")
const [showPass, setShowPass] = useState(false)
const {slug} = useParams()  
const {data, refetch} = useGetBlogDetailsQuery(slug)  
const fileInputRef = useRef(null);
console.log("Printing the id ",slug)
const overviewEditor = useRef(null); 

const {title: initialTitle, description: initialDescription} = data?.data?.blog || {
  title: "",
  description: "",
}


console.log("Printing the title here ",initialTitle)
console.log("Printing the description ", initialDescription)
console.log("Printing the data here ",data?.data)

const [image, setUpdateImage] = useState("")
const [content, setContent] = useState(initialDescription);
const [updateTitle, setUpdateTitle] = useState(initialTitle);
const [showError, setShowError] = useState({
  content: false,
  title: false
})
const navigate = useNavigate()

useEffect(() => {
    if(data){
        setContent(data?.data?.blog?.description)
        setUpdateTitle(data?.data?.blog?.title)
    }
    refetch()
},[data, refetch])

const [postData] = useUpdateBlogMutation()

const handleImageChange = (e) => {
  const file = e.target.files && e.target.files[0];
  if (!file) return;

  const sizeLimit = 2 * 1024 * 1024;
  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];

  const ext = file.name.split('.').pop().toLowerCase();
  const isValidType = allowedTypes.includes(file.type);
  const isValidExtension = allowedExtensions.includes(ext);

  const resetInput = () => {
    setUpdateImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      e.target.type = '';
      e.target.type = 'file';
    }
  };

  if (!isValidType || !isValidExtension) {
    toast.error("Invalid file format. Only JPG, JPEG, PNG, WEBP are allowed.");
    resetInput();
    return;
  }

  if (file.size > sizeLimit) {
    toast.error("File size should be less than 2MB");
    resetInput();
    return;
  }

  const objectUrl = URL.createObjectURL(file);
  const img = new Image();
  img.src = objectUrl;

  img.onload = () => {
    if (img.width === 1500 && img.height === 400) {
      setUpdateImage(file);
    } else {
      toast.error("Image dimensions should be 1500 x 400");
      resetInput();
    }
    URL.revokeObjectURL(objectUrl);
  };

  img.onerror = () => {
    toast.error("Invalid image file.");
    resetInput();
    URL.revokeObjectURL(objectUrl);
  };
};



const handleCreateBlog = (e) => {
 e.preventDefault()
 const checkFeild = {
     title: updateTitle === "",
     content: content === "",
 }
 setShowError(checkFeild);
 const hasError = Object.values(checkFeild).some((error) => error);
 if (hasError) {
 return;
}
const formData = new FormData()
formData.append("title", updateTitle)
formData.append("description", content)
formData.append("image", image)
formData.append("slug", slug)

postData(formData).then((res) => {
 if(res?.data?.success){
     navigate("/admin/blogs")
 }  
 else{
    toast.error(res?.error?.data?.message || "Something went wrong, Please try later.");
 }
})
.catch((err) => {
       console.log(err)
       if (err?.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Something went wrong, Please try later.");
      }
     })
 }

 const handleToggle = () => {
  if (newClass === "") {
    setNewClass("main-active");
    } else {
      setNewClass("");
      }
      if(newSidebarClass === ""){
        setNewSidebarClass("closed");
      }
      else{
        setNewSidebarClass("");
      }
}

  return (
    <>
    <Toaster position='top-right'/>
    <Sidebar
    newSidebarClass={newSidebarClass}
    setShowPass={setShowPass}
    />
    <div className={`main-context ${newClass}`}>
      <Header
      handleToggle={handleToggle}
      />
     <div className="admin-dashboard p-4">
     <div aria-label="breadcrumb">
 <ol className="breadcrumb">
   <li className="breadcrumb-item active" aria-current="page">Update Blog</li>
 </ol>
</div>
<div className="d-flex justify-content-end pe-2 mb-3">
         <Link to="/admin/blogs" className="btn btn-primary rounded-2">
         Back <FaArrowLeft/>
         </Link>
         </div>
         <div className="container card p-4">

          <form className='row gy-3' onSubmit={handleCreateBlog}>
             <div className='col-lg-6'>
            <label htmlFor="title">Blog Title <sup className='text-danger fs-6'>*</sup></label>
              <input
                type="text"
                className="form-control"
                id="title"
                name="title"
                placeholder="Enter Blog Title"
                value={updateTitle}
                onChange={(e) => setUpdateTitle(e.target.value)}
              />
             {
              showError.name && (
                <p className="text-danger wel mt-1 mb-0">Please Provide Blog Title</p>
              )
             }
             </div>
              <div className='col-lg-6'>
            <label htmlFor="image">Image <sup className='text-danger fs-6'>*</sup></label>
              <input
                type="file"
                multiple
                className="form-control"
                id="image"
                name="image"
                onChange={handleImageChange}
                ref={fileInputRef}
              />
             {
              showError.price && (
                <p className="text-danger wel mt-1 mb-0">Please Provide Price</p>
              )
             }
             </div>
            
             <div className='col-lg-6'>
            <label htmlFor="name">Description <sup className='text-danger fs-6'>*</sup></label>
            <JoditEditor
               ref={overviewEditor}
               value={content}
               onChange={(newContent) => 
                   setContent(newContent)
               }
             />
             {
              showError.overview && (
                <p className="text-danger wel mt-1 mb-0">Please Provide Overview</p>
              )
             }
             </div>


             <div className='col-lg-6'>
              
              <div className="row">
                <div className="col-lg-3 border border-2 mt-4">
                  <img src={`${ImgUrl}${blogImgUrl}${data?.data?.blog?.image}`} alt="" width={80}/>
                </div>
              </div>

             </div>
              <div className='col-lg-12 pt-4'>
              <button className="btn btn-primary px-4 rounded-2" type="submit">Submit</button>
              </div>
            </form>
        </div>
        </div>
        </div>
{
      showPass && (
        <ChangePassword
        setShowPass={setShowPass}
        />
      )
    }
    </>
  )
}

export default UpdateBlog